export default __webpack_public_path__ + "static/media/clip_editor.6be1eda7.png";